import {css} from '@emotion/css';
import {LayoutCircleType} from './LayoutSectionCircles.types';
import {colours} from '../../../../../styles/js/variables';

const getType = (type: LayoutCircleType) => {
  switch (type) {
    case LayoutCircleType.LIGHT:
      return `
        color: ${colours.background.GRAY};
      `;
    case LayoutCircleType.MEDIUM:
      return `
        color: ${colours.brand.TERTIARY};
      `;
    case LayoutCircleType.DARK:
      return `
        color: ${colours.font.BLACK};
        opacity: 0.05;
      `;
    case LayoutCircleType.BLUE:
      return `
        color: ${colours.brand.SECONDARY_DISABLED};
      `;
    case LayoutCircleType.BLUE_BRIGHT:
      return `
        color: ${colours.brand.SECONDARY}
        opacity: 0.75;
      `;
    case LayoutCircleType.YELLOW:
      return `
        color: ${colours.brand.PRIMARY};
      `;
    case LayoutCircleType.YELLOW_BRIGHT:
      return `
        color: ${colours.brand.PRIMARY};
        opacity: 0.75;
      `;
    default:
      return '';
  }
};

const styles = {
  multi: css`
    label: layoutCircle__multi;
    position: absolute;
    z-index: 0;
    width: inherit !important;
    margin: inherit !important;
  `,
  multiRow: css`
    label: layoutCircle__multiRow;
    display: flex;
  `,
  circle: (type: LayoutCircleType, imgUrl?: string): string => css`
    label: layoutCircle__circle;
    position: absolute;
    z-index: 0;
    width: 10rem;
    height: auto;
    opacity: 0.2;
    ${getType(type)}
    ${imgUrl &&
    `
      opacity: 1;
    `}
    image {
      width: 100%;
      height: 100%;
    }
  `,
};

export default styles;
